import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Demo from "../components/Demo";
import Main from "../components/main/Main";
import Home from "../components/home/Home";
import Index from "../components/home/Index";
import Login from '../components/login/Login';
import AdminList from '../components/admin/AdminList';
import AdminEdit from '../components/admin/AdminEdit';
import RuleList from '../components/rule/RuleList'
import RuleEdit from '../components/rule/RuleEdit'
import GroupList from '../components/group/GroupList'
import GroupEdit from '../components/group/GroupEdit'
import CategoryList from '../components/category/CategoryList'
import QueueList from '@/components/queue/QueueList'
import QueueDelayList from '@/components/queue/QueueDelayList'
// import GoodsList from '@/components/goods/GoodsList'
// import GoodsEdit from '@/components/goods/GoodsEdit'
import Test from '@/components/test/Test'
import BatchEmail from '../components/batch/BatchEmail.vue'

Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }



export default new Router({
  routes: [

    {
      path: '/',
      name: 'Page',
      redirect:{name:'Home'}
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo
    },
    {
      path:'/main',
      name:'Main',
      component:Main,
      children:[
        {
          path:'home',
          name:'Home',
          component:Home
        },
        {
          path: 'index',
          name: "Index",
          component: Index
        },
        {
          path:"admin_list",
          name:"AdminList",
          component:AdminList
        },
        {
          path:"admin_edit",
          name:"AdminEdit",
          component:AdminEdit
        },
        {
          path:"rule_list",
          name:"RuleList",
          component:RuleList
        },
        {
          path:"rule_edit",
          name:"RuleEdit",
          component:RuleEdit
        },
        {
          path:"group_list",
          name:"GroupList",
          component:GroupList
        },
        {
          path:"group_edit",
          name:"GroupEdit",
          component:GroupEdit
        },
        {
          path:"category_list",
          name:"CategoryList",
          component:CategoryList
        },
        {
          path:"queue_list",
          name:"QueueList",
          component:QueueList
        },
        {
          path:"queue_delay_list",
          name:"QueueDelayList",
          component:QueueDelayList
        },
        {
          path:"test",
          name:"Test",
          component:Test
        },
        {
          path:"batch_email",
          name:"BatchEmail",
          component:BatchEmail
        },
        {
          path:"cms",
          name:"Cms",
          component:()=>import('../components/cms.vue')
        },
        {
          path:'article_edit',
          name:'ArticleEdit',
          component:()=>import('../components/article/ArticleEdit.vue')

        },
        {
          path:'article_list',
          name:'ArticleList',
          component:()=>import('../components/article/ArticleList.vue')

        },
        {
          path:'draft_article_edit',
          name:'DraftArticleEdit',
          component:()=>import('../components/article/DraftArticleEdit.vue')

        },
        {
          path:'draft_article_list',
          name:'DraftArticleList',
          component:()=>import('../components/article/DraftArticleList.vue')

        },
        {
          path:'expand_edit',
          name:'ExpandEdit',
          component:()=>import('../components/category/ExpandEdit.vue')

        },
        {
          path:'expand_list',
          name:'ExpandList',
          component:()=>import('../components/category/ExpandList.vue')

        },
        {
          path:'mode_edit',
          name:'ModeEdit',
          component:()=>import('../components/mode/ModeEdit')
        },
        {
          path:'mode_list',
          name:'ModeList',
          component:()=>import('../components/mode/ModeList')
        },
        {
          path:'category_edit',
          name:'CategoryEdit',
          component:()=>import('../components/category/CategoryEdit')
        },
        {
          path:'user_list',
          name:'UserList',
          component:()=>import('../components/user/UserList')
        },
        {
          path:'gift_list',
          name:'GiftList',
          component:()=>import('../components/gift/GiftList')
        },
        {
          path:'code_list',
          name:'CodeList',
          component:()=>import('../components/gift/CodeList')
        },
        {
          path:'site_setting',
          name:'SiteSetting',
          component:()=>import('../components/setting/SiteSetting')
        },
        {
          path:'file_list',
          name:"FileList",
          component:()=>import('../components/file/FileList')


        },
        {
          path:'sitemap',
          name:"FileList",
          component:()=>import('../components/setting/SiteMap')


        },
        {
          path:'href_list',
          name:"HrefList",
          component:()=>import('../components/setting/HrefList')


        },
        {
          path:'href_edit',
          name:"HrefList",
          component:()=>import('../components/setting/HrefEdit')


        },
        {
          path:"article_task_list",
          name:"ArticleTaskList",
          component:()=>import('../components/article_task/ArticleTaskList')
        },
        {
          path:"link_update_edit",
          name:"LinkUpdateEdit",
          component:()=>import('../components/article/LinkUpdateEdit')
        },
        {
          path:"link_update_list",
          name:"LinkUpdateList",
          component:()=>import('../components/article/LinkUpdateList')
        },
        {
          path:"page_edit",
          name:"PageEdit",
          component:()=>import('../components/page/PageEdit')
        },
        {
          path:"page_list",
          name:"PageList",
          component:()=>import('../components/page/PageList')
        },
        {
          path: "statistics_edit",
          name:"StatisticsEdit",
          component: ()=>import("../components/statistics/StatisticsEdit")
        },
        {
          path: "statistics_list",
          name:"StatisticsList",
          component: ()=>import("../components/statistics/StatisticsList")
        },
        {
          path:"word_edit",
          name:"WoldEdit",
          component:()=>import('../components/article/WordEdit')
        },
        {
          path:"Article_hy_list",
          name:"ArticleHyList",
          component:()=>import('../components/article/ArticleHyList')
        },
        {
          path:"Article_hy_Edit",
          name:"ArticleHyEdit",
          component:()=>import('../components/article/ArticleHyEdit')
        }








        // {
        //   path:"goods_list",
        //   name:"GoodsList",
        //   component:GoodsList
        // },
        // {
        //   path:"goods_edit",
        //   name:"GoodsEdit",
        //   component:GoodsEdit
        // },



      ]
    },
    {
      path:'/login',
      name:"Login",
      component:Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js